import React, { Component } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import SimplyServeSmall from "../images/SimplyServeSmall.png";
import ReactGA from "react-ga";
import DatePicker from "../components/datepicker";
import "../css/contact.css";

class Demo extends Component {
  state = {
    formData: {
      yourName: "",
      email: "",
      phone: "",
      restaurantName: "",
      restaurantAddress: undefined,
      time: "10am",
      date: null,
      message: undefined,
    },
    submitting: false,
    message: "",
  };
  constructor(props) {
    super(props);

    this.recaptchaRef = React.createRef();

    let firstAvailable = new Date();
    firstAvailable.setHours(0, 0, 0, 0);
    firstAvailable.setDate(firstAvailable.getDate() + 2);

    if (firstAvailable.getDay() === 0)
      firstAvailable.setDate(firstAvailable.getDate() + 1);

    if (firstAvailable.getDay() === 6)
      firstAvailable.setDate(firstAvailable.getDate() + 2);

    console.log(firstAvailable);

    this.state.formData.date = firstAvailable;
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  setDate = (date) => {
    console.log(date);
    let formData = this.state.formData;
    formData.date = date;
    this.setState({ formData }, () => console.log(this.state.formData));
  };
  submitForm = async (event) => {
    event.preventDefault(0);
    this.setState({ submitting: true });
    await this.postSubmission();
    this.setState({ submitting: false });
  };

  postSubmission = async () => {
    const formId = "6n8xAVNX";
    const formSparkUrl = "https://submit-form.com/" + formId;
    const payload = {
      ...this.state.formData,
      "g-recaptcha-response": this.state.recaptchaToken,
    };

    payload.date.setTime(payload.date.getTime() + 1 * 60 * 60 * 1000);

    try {
      const result = await axios.post(formSparkUrl, payload);
      window.scrollTo(0, 0);
      this.setState({
        message: {
          class: "green",
          message: "Thanks. We'll be in touch to confirm shortly.",
        },
        formData: {
          yourName: "",
          email: "",
          phone: "",
          restaurantName: "",
          restaurantAddress: undefined,
          date: payload.date,
          time: "10am",
          message: undefined,
        },
      });
      this.recaptchaRef.current.reset();
    } catch (err) {
      this.setState({
        message: {
          class: "red",
          message: "Sorry, there was a problem. Please try again.",
        },
      });
    }
  };

  updateFormControl = (event) => {
    const { id, value } = event.target;
    const formKey = id;
    const updateFormState = { ...this.state.formData };
    updateFormState[formKey] = value;
    this.setState({ formData: updateFormState });
  };

  updateRecaptchaToken = (token) => {
    this.setState({ recaptchaToken: token });
  };

  timePicker = () => {
    const times = [
      "9am",
      "10am",
      "11am",
      "12pm",
      "1pm",
      "2pm",
      "3pm",
      "4pm",
      "5pm",
    ];

    return (
      <div
        className={
          this.state.showTimePicker ? "time-picker show" : "time-picker"
        }
      >
        {times.map((time) => (
          <div
            className="time-option"
            key={time}
            onClick={() => {
              const formData = this.state.formData;
              formData.time = time;
              this.setState({ showTimePicker: false, formData });
            }}
          >
            {time}
          </div>
        ))}
      </div>
    );
  };

  render() {
    const recaptchaKey = process.env.REACT_APP_ReCAPTCHA_KEY;

    // Next available date is today + 2, but must be a monday

    let firstAvailable = new Date();
    firstAvailable.setHours(0, 0, 0, 0);
    firstAvailable.setDate(firstAvailable.getDate() + 2);

    if (firstAvailable.getDay() === 0)
      firstAvailable.setDate(firstAvailable.getDate() + 1);

    if (firstAvailable.getDay() === 6)
      firstAvailable.setDate(firstAvailable.getDate() + 2);

    return (
      <div className="page contact">
        <div className="page-title">
          SimplyServe
          <img src={SimplyServeSmall} alt="logo" />
          <div className="page-sub-title">book a demo</div>
        </div>
        <div className="message-container">
          <div className="message">
            <div className="content">
              <h2>book a demo</h2>

              {this.state.message && (
                <div className={this.state.message.class}>
                  {this.state.message.message}
                </div>
              )}
              <form onSubmit={this.submitForm}>
                <label for="restaurantName">Restaurant Name</label>
                <input
                  type="text"
                  id="restaurantName"
                  name="restaurantName"
                  placeholder="Restaurant"
                  required=""
                  value={this.state.formData.restaurantName}
                  onChange={this.updateFormControl}
                />
                <label for="restaurantAddress">Restaurant Address</label>
                <textarea
                  id="restaurantAddress"
                  name="restaurantAddress"
                  placeholder="Address"
                  required=""
                  onChange={this.updateFormControl}
                  value={this.state.formData.restaurantAddress}
                />
                <DatePicker
                  onNewDate={this.setDate}
                  firstAvailable={firstAvailable}
                  selectedDate={
                    this.state.formData.date === null
                      ? firstAvailable
                      : this.state.formData.date
                  }
                />
                <div
                  className="time-option selected"
                  style={{ position: "relative" }}
                  onClick={() =>
                    this.setState({
                      showTimePicker: this.state.showTimePicker ? false : true,
                    })
                  }
                >
                  {this.state.formData.time}

                  {this.timePicker()}
                </div>

                <label for="yourName">Your Name</label>
                <input
                  type="text"
                  id="yourName"
                  name="yourName"
                  placeholder="Name"
                  required=""
                  value={this.state.formData.yourName}
                  onChange={this.updateFormControl}
                />
                <label for="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  required=""
                  value={this.state.formData.email}
                  onChange={this.updateFormControl}
                />
                <label for="phone">Phone</label>
                <input
                  type="number"
                  id="phone"
                  name="phone"
                  placeholder="Phone"
                  required=""
                  value={this.state.formData.phone}
                  onChange={this.updateFormControl}
                />

                <label for="message">Additional</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Anything you'd like us to know?"
                  required=""
                  onChange={this.updateFormControl}
                  value={this.state.formData.message}
                />

                <ReCAPTCHA
                  ref={this.recaptchaRef}
                  sitekey={recaptchaKey}
                  onChange={this.updateRecaptchaToken}
                />
                <button type="submit" disabled={this.state.submitting}>
                  {this.state.submitting ? "Booking..." : "Book"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Demo;
